import { motion } from "framer-motion";
import { TID } from "@/lib/testIds";
import { NumberTicker } from "@/components/magicui/number-ticker";
import TextReveal from "./TextReveal";

const STATS = [
  { value: 200, prefix: "₹", suffix: " Cr+", label: "Subsidies & grants sanctioned" },
  { value: 1300, suffix: "+", label: "MSME cases handled" },
  { value: 8, suffix: "+ yrs", label: "Policy & arbitration expertise" },
  { text: "DPIIT", label: "Recognized · Govt. of India" },
];

export const StatsBar = () => (
  <section
    id="stats"
    data-testid={TID.stats.root}
    className="relative bg-paper border-y border-navy/10 overflow-hidden"
  >
    {/* Brand ambient orbs */}
    <div aria-hidden className="absolute -left-40 -top-40 h-[360px] w-[360px] rounded-full bg-[color:var(--violet)]/12 blur-[130px]" />
    <div aria-hidden className="absolute -right-40 -bottom-40 h-[360px] w-[360px] rounded-full bg-[color:var(--gold)]/15 blur-[130px]" />

    <div className="relative mx-auto max-w-[1400px] grid grid-cols-2 lg:grid-cols-4">
      {STATS.map((s, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10% 0px" }}
          transition={{ delay: i * 0.1, duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className={`relative px-6 md:px-10 py-10 md:py-14 ${
            i > 0 ? "lg:border-l" : ""
          } ${i % 2 === 1 ? "border-l lg:border-l" : ""} ${
            i >= 2 ? "border-t lg:border-t-0" : ""
          } border-navy/10`}
        >
          <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-navy/50">
            0{i + 1}
          </span>
          <div className="mt-4 font-serif tracking-tight text-4xl md:text-5xl lg:text-6xl text-navy tabular-nums">
            {s.text ? (
              <span>{s.text}</span>
            ) : (
              <>
                {s.prefix}
                <NumberTicker value={s.value} duration={1800} />
                <span className="text-[color:var(--gold)]">{s.suffix}</span>
              </>
            )}
          </div>
          <p className="mt-3 text-sm md:text-[15px] text-navy/70 max-w-[22ch] leading-snug">
            <TextReveal>{s.label}</TextReveal>
          </p>
        </motion.div>
      ))}
    </div>
  </section>
);

export default StatsBar;
